import { Link, useLocation } from "react-router-dom";
import { logout } from "../utils/auth";
import "../styles/admin.css";

const icons = {
    dashboard: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>,
    committee: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
    events: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
    gallery: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>,
    sponsors: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"></path></svg>,
    tiers: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>,
    members: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><polyline points="16 11 18 13 22 9"></polyline></svg>,
    messages: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>,
    logout: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
};

function Sidebar({ isCollapsed }) {
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    const navItemStyle = (path) => ({
        display: "flex",
        alignItems: "center",
        gap: isCollapsed ? "0" : "12px",
        justifyContent: isCollapsed ? "center" : "flex-start",
        color: isActive(path) ? "var(--primary)" : "var(--text-muted)",
        textDecoration: "none",
        padding: "12px",
        borderRadius: "10px",
        fontWeight: "600",
        fontSize: "0.95rem",
        transition: "all 0.2s",
        backgroundColor: isActive(path) ? "rgba(99, 102, 241, 0.08)" : "transparent",
        marginBottom: "4px"
    });

    return (
        <div
            className="layout-transition custom-scrollbar"
            style={{
                width: isCollapsed ? "80px" : "260px",
                background: "var(--bg-sidebar)",
                height: "100vh",
                padding: "24px 12px",
                boxSizing: "border-box",
                borderRight: "1px solid var(--border)",
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                left: 0,
                top: 0,
                zIndex: 100,
                overflowY: "auto",
                overflowX: "hidden"
            }}
        >
            <div style={{ 
                padding: isCollapsed ? "0 0 32px 0" : "0 8px 32px 8px", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: isCollapsed ? "center" : "flex-start",
                minHeight: "60px"
            }}>
                <img 
                    src="/images/MKS-LOGO.png" 
                    alt="MKS Logo" 
                    style={{ 
                        width: isCollapsed ? "42px" : "160px", 
                        height: "auto",
                        marginTop: "20px",
                        objectFit: "contain",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.05))"
                    }} 
                />
            </div>

            <nav style={{ flex: 1, marginTop: "20px" }}>
                <Link style={navItemStyle("/dashboard")} to="/dashboard">
                    {icons.dashboard}
                    {!isCollapsed && "Dashboard"}
                </Link>
                <div style={{ height: "20px" }}></div>

                {!isCollapsed && <p style={{ fontSize: "0.75rem", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", padding: "0 16px 8px", whiteSpace: "nowrap" }}>Management</p>}

                <Link style={navItemStyle("/committee")} to="/committee">
                    {icons.committee}
                    {!isCollapsed && "Committee"}
                </Link>
                <Link style={navItemStyle("/events")} to="/events">
                    {icons.events}
                    {!isCollapsed && "Events"}
                </Link>
                <Link style={navItemStyle("/gallery")} to="/gallery">
                    {icons.gallery}
                    {!isCollapsed && "Gallery"}
                </Link>
                <Link style={navItemStyle("/sponsors")} to="/sponsors">
                    {icons.sponsors}
                    {!isCollapsed && "Sponsors"}
                </Link>

                <div style={{ height: "20px" }}></div>
                {!isCollapsed && <p style={{ fontSize: "0.75rem", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", padding: "0 16px 8px", whiteSpace: "nowrap" }}>Organization</p>}

                <Link style={navItemStyle("/sponsor-tiers")} to="/sponsor-tiers">
                    {icons.tiers}
                    {!isCollapsed && "Sponsor Tiers"}
                </Link>
                <Link style={navItemStyle("/membership-types")} to="/membership-types">
                    {icons.tiers}
                    {!isCollapsed && "Membership Types"}
                </Link>

                <div style={{ height: "20px" }}></div>
                {!isCollapsed && <p style={{ fontSize: "0.75rem", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", padding: "0 16px 8px", whiteSpace: "nowrap" }}>Records</p>}

                <Link style={navItemStyle("/memberships")} to="/memberships">
                    {icons.members}
                    {!isCollapsed && "Memberships"}
                </Link>
                <Link style={navItemStyle("/donations")} to="/donations">
                    {icons.sponsors}
                    {!isCollapsed && "Donations"}
                </Link>
                <Link style={navItemStyle("/messages")} to="/messages">
                    {icons.messages}
                    {!isCollapsed && "Messages"}
                </Link>
            </nav>

            <button
                onClick={logout}
                className="btn btn-outline"
                style={{
                    width: "100%",
                    marginTop: "auto",
                    justifyContent: isCollapsed ? "center" : "flex-start",
                    gap: isCollapsed ? "0" : "12px",
                    color: "var(--danger)",
                    borderColor: "transparent",
                    background: "rgba(239, 68, 68, 0.05)",
                    padding: isCollapsed ? "12px" : "10px 18px"
                }}
            >
                {icons.logout}
                {!isCollapsed && "Logout"}
            </button>
        </div>
    );
}

export default Sidebar;